import { Component, OnInit } from '@angular/core';
import { NgForm} from '@angular/forms';
import { NULL_EXPR } from '@angular/compiler/src/output/output_ast';
import { ActivatedRoute, Router } from '@angular/router';
//import { AdataService } from '../../shared/adata.service';
import Swal from 'sweetalert2';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-pigmyremittance',
  templateUrl: './pigmyremittance.component.html',
  styleUrls: ['./pigmyremittance.component.css']
})
export class PigmyremittanceComponent implements OnInit {
  title = "Pigmy Remittance"
  branchdata:any;
  branchopt:any[];
  b:any={};
  agentdata:any;
  AgentsList: any = [];
  g:any={};
  amountdata:any;
  amountopt:any[];
  a:any={};
  remittancedata:any;
  remittanceopt:any[];
  formd:any={};
  pr:any={};
  c:any={};
  sub:any={};
  tot:any;
  data : any = {};
  today = new Date(); 
  DateValues:string; 
  logbranch: any;

  constructor( private service : UserService,private router: Router,private route: ActivatedRoute,private datePipe:DatePipe) { }

  ngOnInit() {
    this.loadbranch();
    this. GetAgentData();
    this.formd.remdt=this.getdatefun(this.today);
    this.logbranch=localStorage.getItem('BRANCH_ID');
    this.formd.BRANCH_ID=this.logbranch;

  }
  
  getdatefun(indt:any)
  {
    debugger;
    this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
  }

  loadbranch()
  {
    
    this.branchdata=this.service.getbranch1();
    this.branchdata.subscribe(
      (response:any)=>{
        this.branchopt=response.BranchModels;
        console.log(response.BranchModels);
        });
        
    }

   
    GetAgentData(){
      debugger;
    this.data = this.service.GetAllAgents();
    this.data.subscribe(
         (response: any) => {         
          this.AgentsList= response;        
  }
  ) 
}


    loadagentcode(agnt:any,branchn:number,dt_gt:any)
    {
      this.AGENT_IDempty=false;
        this.formd.agentname=agnt;
        this.formd.sub="";
        this.loadRemiDetails(branchn,agnt,this.chckdt(dt_gt));
        
             
    }

    loadRemiDetails(branchCode:number,schemecode:number,entrydate:Date) {
      debugger;
      
        
 
      this.remittancedata = this.service.getPigmyRemiDetails(branchCode,schemecode,this.chckdt(entrydate));
      this.remittancedata.subscribe(
        (response: any) => 
        {
          
          this.remittanceopt = response;
          this.getCount(schemecode);
          console.log(this.remittanceopt);
          
          debugger;
   
         
          },
        (error) => {
          //document.getElementById('loader-spinner').style.display = "none";
        }
      );
  
    }

    getCount(agntid:number)
    {
      let count=0;
      debugger;
      for(var i=0;i<this.remittanceopt .length;i++)
    {
      if(this.remittanceopt [i].TRANS_AMT!=0)
      {
        
        count+= this.remittanceopt [i].TRANS_AMT;
        console.log(count);
       
      }
     
      debugger;
      this.formd.TRANS_AMT=count;
    }
    }  


      resetForm(form? : NgForm){
        swal({
        title:'Are you sure?',
        text: "You want to Cancel this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Clear it!'
      }).then((result) => {
      if (result.value) {
        swal(
         'Cleared!',
         'Your file has been Cleared.',
         'success'
        )
      if(form !=null)
     form.reset();
     this.c.branchdata='';
     
     this.c.agentdata='';
     this.c.remittancedata='';
     this.remittanceopt=null;
    
    }
    });
    }

    AGENT_IDempty:boolean=false;
    gt_dtempty:boolean=false;
    gt_dtfilled()
    {
      this.gt_dtempty=false;
      if(this.formd.gt_dt.length>10)
        {
          this.formd.gt_dt="";
          swal('Date','Date not correct','warning');
        }
    }
  
    onSubmit(form:NgForm)
    {  
    if(this.formd.BRANCH_ID==undefined||null || this.formd.gt_dt==undefined||null || this.formd.AGENT_ID==undefined||null)
   {
     if(this.formd.gt_dt==undefined||null )
        this.gt_dtempty=true;
     if(this.formd.AGENT_ID==undefined||null)
     {
      this.AGENT_IDempty=true;
     }
       swal('No Data','cannot save empty data','warning');
   }
   else if(this.formd.TRANS_AMT<=0 || this.formd.TRANS_AMT==undefined||null)
   {
     swal('No Collection','No Collection amount to Remit','warning');
   }
   else{
     this.insertPigmyRem(form);
   swal(
     'Success!',
     'Your file has been Saved.',
     'success'
    )
    this.c.remittancedata='';
    this.remittanceopt=null;
    this.formd.TRANS_AMT='';

   }
       
 }

  insertPigmyRem(formd: NgForm)
   {
  debugger;
  this.service.createPigmyRemittance(formd.value).subscribe(res=>{
    //this.resetForm(formd)
    formd.reset();   
  })
}

chckdt(arg:Date)
{
if(arg!=null)
{
  return arg;
}
}


}



// WEBPACK FOOTER //
// ./src/app/general-transaction/pigmyremittance/pigmyremittance.component.ts